<template>
  <div>
    <v-card>
      <v-card-title>
        All NPOs
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-btn
          class='info'
          small
          style='margin-top : 15px; margin-right : 15px'
          @click='dialog = true'
        >Add NPO</v-btn>
        <v-btn
          small
          style='margin-top : 15px; margin-right : 15px'
          @click='downloadCSV'
        >Download CSV</v-btn>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-model='selected'
        :headers="headers"
        :items="npos"
        :search="search"
      >
        <template v-slot:item.id="{item }">
          <a
            href='#'
            @click='editDialog = true;selectedNPO = item'
          >{{item.id}}</a>
        </template>

      </v-data-table>
    </v-card>

    <v-dialog
      v-model="editDialog"
      max-width="600px"
    >
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="headline">Edit {{selectedNPO.name}}</span>
            <h2
              v-if='selectedNPO.disabled'
              class='red--text'
            >This account is disabled</h2>
          </v-card-title>
          <v-card-text>

            <v-container>
              <v-row>

                <v-col cols="12">
                  <v-text-field
                    :disabled='selectedNPO.disabled'
                    v-model='selectedNPO.name'
                    label="Company Name*"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model='selectedNPO.email'
                    label="Contact Email* (this will also be your login username)"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model='selectedNPO.address'
                    :disabled='selectedNPO.disabled'
                    label="Address"
                  ></v-text-field>
                  <v-text-field
                    v-model='selectedNPO.phoneNumber'
                    :disabled='selectedNPO.disabled'
                    label="Phone Number"
                  ></v-text-field>

                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-subheader class='red--text'>Danger Zone</v-subheader>
              <v-btn
                :disabled='selectedNPO.disabled'
                :loading='disableBtnLoading'
                @click='disabledAccounts'
                class='warning ma-5'
              >Disable All Accounts</v-btn>
            </v-container>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="editDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="saveData()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      max-width="600px"
    >
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="headline">Edit {{selectedNPO.name}}</span>
          </v-card-title>
          <v-card-text>

            <v-container>
              <v-row>

                <v-col cols="12">
                  <v-text-field
                    v-model='createNPO.name'
                    label="Company Name*"
                    :rules="[v => !!v || 'Item is required']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model='createNPO.email'
                    label="Contact Email* (this will also be your login username)"
                    :rules="[v => !!v || 'Item is required']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model='createNPO.address'
                    :rules="[v => !!v || 'Item is required']"
                    required
                    label="Address"
                  ></v-text-field>
                  <v-text-field
                    v-model='createNPO.phoneNumber'
                    :rules="[v => !!v || 'Item is required']"
                    required
                    label="Phone Number"
                  ></v-text-field>
                  <v-select
                    persistent-hint
                    v-model="selectedRefurbisher"
                    :items="refurbishers"
                    :rules="[v => !!v || 'Item is required']"
                    required
                    item-text="name"
                    item-value="id"
                    label="Select a Refurbisher"
                    return-object
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialog = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addNPO()"
            >
              Add
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

  </div>
</template>

<script>
import shortid from "shortid";
import papa from "papaparse";
const fb = require("../../firebaseconfig");
export default {
  data() {
    return {
      selectedNPO: {
        name: null,
        address: null,
        phoneNumber: null,
        email: null,
        id: null,
        refurb: null,
      },
      disableBtnLoading: false,
      selectedRefurbisher: null,
      createNPO: {
        disabled: false,
        accounts: [],
        numberofdonations: 0,
        name: null,
        address: null,
        phoneNumber: null,
        email: null,
        id: shortid.generate(),
        refurb: null,
        techSpecID: "",
      },
      valid: true,
      editDialog: false,
      dialog: false,
      selected: [],
      headers: [
        { text: "ID", value: "id" },
        { text: "Donations", value: "numberofdonations" },
        { text: "Name", value: "name", filterable: true },
        { text: "Email", value: "email" },
        { text: "Address", value: "address" },
        { text: "Phone #", value: "phoneNumber" },
      ],
      search: null,
      donations: null,
      refurbishers: [],
      npos: [],
      totalDonations: [],
    };
  },
  async mounted() {
    await this.getRefurbisher();
    await this.getNpos();
  },
  methods: {
    disabledAccounts() {
      this.disableBtnLoading = true;
      this.$axios
        .post(
          "https://us-central1-donorconnection-df169.cloudfunctions.net/adminapi/disableAccounts",
          {
            refurbisher: this.selectedNPO.id,
            type: "ngo",
          },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          this.disableBtnLoading = false;
          this.editDialog = false;
          fb.db
            .collection("ngo")
            .doc(this.selectedNPO.id)
            .update({ disabled: true });
        });
    },

    async saveData() {
      await fb.db.collection("ngo").doc(this.selectedNPO.id).update({
        name: this.selectedNPO.name,
        address: this.selectedNPO.address,
        phoneNumber: this.selectedNPO.phoneNumber,
      });
      this.editDialog = false;
    },
    async addNPO() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        let exist = await this.$axios.post(
          "https://us-central1-donorconnection-df169.cloudfunctions.net/adminapi/validateEmail",
          {
            email: this.createNPO.email,
          },
          { headers: { "Content-Type": "application/json" } }
        );
        if (exist.data === false) {
          this.createNPO.refurb = this.selectedRefurbisher.id;
          this.createNPO.techSpecID = this.selectedRefurbisher.techSpecID;
          this.createNPO.accounts.push(this.createNPO.email);
          await fb.db
            .collection("ngo")
            .doc(this.createNPO.id)
            .set(this.createNPO);
          await fb.db
            .collection("refurb")
            .doc(this.selectedRefurbisher.id)
            .update({
              nonprofitsId: fb.firestore.FieldValue.arrayUnion(
                this.createNPO.id
              ),
              ngoData: fb.firestore.FieldValue.arrayUnion({
                id: this.createNPO.id,
                name: this.createNPO.name,
              }),
            });
          await fb.db
            .collection("admin")
            .doc("counter")
            .update({
              totalNpo: fb.firestore.FieldValue.increment(1),
            });
          this.dialog = false;
        } else {
          alert("email already exist");
          this.dialog = false;
        }
      }
    },
    downloadCSV() {
      let csv = papa.unparse(this.npos);
      var csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      var csvURL = null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, "download.csv");
      } else {
        csvURL = window.URL.createObjectURL(csvData);
      }

      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", "download.csv");
      tempLink.click();
    },
    goTo(item) {
      this.$router.push("/donations/" + item.id);
    },
    async getRefurbisher() {
      await fb.db.collection("refurb").onSnapshot((query) => {
        this.refurbishers = [];
        query.forEach((refurb) => {
          this.refurbishers.push(refurb.data());
        });
      });
    },
    async getNpos() {
      fb.db.collection("ngo").onSnapshot((query) => {
        this.npos = [];
        this.npos = query.docs.map((data) => data.data());
      });
    },
  },
};
</script>